export type ProjectCreateConversationMode = 'new_project' | 'update_current_draft';

/** 用户明确要求跨越当前草稿、开启一个新的项目创建流程。 */
export function isExplicitNewProjectIntent(text: string): boolean {
  const t = String(text ?? '').toLowerCase().replace(/\s+/g, '');
  if (!t) return false;
  return (
    /(?:新建|新增|重新创建|重新新建|再创建|再建|另建|另一个|全新).{0,16}(?:项目|项目方案|项目计划)/.test(t)
    || /(?:创建|新建|新增|开始|开启|发起).{0,8}新(?:的)?项目/.test(t)
  );
}

/** Dashboard/历史会话中，只有非创建会话才需要先分叉，避免把新建请求追加到旧会话。 */
export function shouldForkProjectCreateConversation(args: {
  explicitNew: boolean;
  hasUserMessages: boolean;
  lastAssistantSuggestedCreateProject: boolean;
}): boolean {
  if (args.explicitNew) return true;
  return args.hasUserMessages && !args.lastAssistantSuggestedCreateProject;
}

/**
 * 决定本轮是否延续“创建项目”流程。
 * 已有项目页只接受本轮明确的创建意图；历史 thought 与模糊补充文本不得劫持当前项目查询。
 */
export function shouldContinueProjectCreateConversation(args: {
  routeName: string;
  hasProjectContext: boolean;
  hasPendingPageEdit: boolean;
  createIntent: boolean;
  lastAssistantSuggestedCreateProject: boolean;
  likelyCreateSupplement: boolean;
}): boolean {
  if (args.hasPendingPageEdit) return false;
  if (args.routeName === 'ProjectCreate') return true;
  if (args.createIntent) return true;
  if (args.hasProjectContext) return false;
  return args.lastAssistantSuggestedCreateProject || args.likelyCreateSupplement;
}
